import React, { useState } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Grid, Button } from "@material-ui/core";
import "./BookingPage.sass";
import NewBooking from "./NewBooking/index";
import ImagineBooking from "./NewBooking/ImagingBooking";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 0,
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    content: {
      width: "100%",
      flexGrow: 21,
    },
    contentHeader: {
      width: "100%",
      padding: "0px 10px 40px 10px",
    },
    leftContentHeader: {
      width: "50%",
      float: "left",
    },
    rightContentHeader: {
      width: "50%",
      float: "right",
      textAlign: "right",
      paddingRight: "20px",
    },
    contentTable: {
      width: "100%",
      padding: "0px 0px 10px 0px",
      marginTop: "40px",
      minHeight: "300px",
    },
  })
);

interface Props {}

const BookingPage: React.FC<Props> = () => {
  const classes = useStyles();
  const [newBooking, setNewBooking] = useState<Boolean>(true);

  return (
    <>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Grid
          container
          spacing={3}
          direction="row"
          alignItems="center"
          justify="center"
        >
          <Grid item xs={12} sm={6} md={3}>
            <Button
              variant="contained"
              style={{
                marginLeft: "1rem",
                marginBottom: "1rem",
                background: newBooking ? "#924A91" : "",
              }}
              onClick={() => setNewBooking(true)}
              fullWidth
            >
              HOME DX
            </Button>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Button
              variant="contained"
              style={{
                marginLeft: "1rem",
                marginBottom: "1rem",
                background: !newBooking ? "#924A91" : "",
              }}
              onClick={() => setNewBooking(false)}
              fullWidth
            >
              IMAGING
            </Button>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <h2 style={{ marginLeft: "1rem", marginBottom: "1rem" }}>
              {newBooking ? "CC BOOKING PAGE" : "IMAGING BOOKING PAGE"}
            </h2>
          </Grid>
        </Grid>
        <div className={classes.contentTable}>
          {newBooking ? <NewBooking /> : <ImagineBooking />}
        </div>
      </main>
    </>
  );
};

export default BookingPage;
